import React, { Component } from 'react';
import { flowRight as compose } from 'lodash';
import { withQuery, withMutation } from '../../../hoc/withGraphql';
import getSupportTickets from './getSupportTickets.graphql';
import getTicketQ from './getTicket.graphql';
import createTicketM from './createTicket.graphql';
import updateTicketM from './updateTicket.graphql';
import addTicketMessageM from './addTicketMessage.graphql';

const RED = '#D32F2F';
const INK = '#1F2733';

class SupportTickets extends Component {
  constructor(props) {
    super(props);
    this.state = {
      statusFilter: '', selectedId: null, busy: false, message: '', reply: '',
      nf: false, nSubject: '', nDescription: '', nUserEmail: '', nBooking: '', nPriority: 'normal', nCategory: 'other',
    };
  }

  refetchList = () => this.props.tickets.refetch({ statusFilter: this.state.statusFilter || undefined });
  open = (id) => { this.setState({ selectedId: id, message: '', reply: '' }); this.props.ticket.refetch({ id }); };

  createTicket = async () => {
    if (!this.state.nSubject) { this.setState({ message: 'Subject required.' }); return; }
    this.setState({ busy: true, message: '' });
    try {
      const res = await this.props.createMut({ variables: {
        subject: this.state.nSubject, description: this.state.nDescription || undefined,
        userEmail: this.state.nUserEmail || undefined, bookingId: this.state.nBooking ? Number(this.state.nBooking) : undefined,
        category: this.state.nCategory, priority: this.state.nPriority,
      } });
      const r = res && res.data && res.data.createTicket;
      if (r && r.status === 200) { this.setState({ busy: false, nf: false, nSubject: '', nDescription: '', nUserEmail: '', nBooking: '', message: '✅ Ticket created.' }); this.refetchList(); }
      else this.setState({ busy: false, message: (r && r.errorMessage) || 'Failed.' });
    } catch (e) { this.setState({ busy: false, message: e.message }); }
  };

  update = async (vars) => {
    this.setState({ busy: true, message: '' });
    try {
      await this.props.updateMut({ variables: { id: this.state.selectedId, ...vars } });
      this.setState({ busy: false });
      this.props.ticket.refetch({ id: this.state.selectedId });
      this.refetchList();
    } catch (e) { this.setState({ busy: false, message: e.message }); }
  };

  sendReply = async () => {
    if (!this.state.reply) return;
    this.setState({ busy: true });
    try {
      await this.props.replyMut({ variables: { ticketId: this.state.selectedId, body: this.state.reply } });
      this.setState({ busy: false, reply: '' });
      this.props.ticket.refetch({ id: this.state.selectedId });
      this.refetchList();
    } catch (e) { this.setState({ busy: false, message: e.message }); }
  };

  render() {
    const list = (this.props.tickets && this.props.tickets.getSupportTickets) || {};
    const rows = list.results || [];
    const t = (this.props.ticket && this.props.ticket.getTicket) || null;

    const input = { padding: '8px 10px', border: '1px solid #ddd', borderRadius: 8, fontSize: 14, marginRight: 8 };
    const btn = (bg) => ({ background: bg, color: '#fff', border: 'none', padding: '6px 12px', borderRadius: 8, fontWeight: 600, cursor: 'pointer', marginRight: 6, fontSize: 13 });
    const th = { padding: 9, textAlign: 'left' };
    const td = { padding: 9, borderTop: '1px solid #f0f0f0', fontSize: 13 };
    const sBadge = (s) => {
      const c = { open: '#F9A825', in_progress: '#1565C0', resolved: '#2E7D32', closed: '#9E9E9E' }[s] || '#9E9E9E';
      return { padding: '2px 9px', borderRadius: 999, fontSize: 11, fontWeight: 700, color: '#fff', background: c };
    };
    const pBadge = (p) => ({ padding: '2px 8px', borderRadius: 999, fontSize: 11, fontWeight: 700, color: '#fff', background: { high: '#C62828', normal: '#607D8B', low: '#9E9E9E' }[p] || '#607D8B' });

    return (
      <div style={{ fontFamily: 'Poppins, sans-serif' }}>
        <h1 className="siteAdminPrimaryHeading">Support Tickets {list.openCount ? `(${list.openCount} open)` : ''}</h1>

        <div style={{ background: '#fff', border: '1px solid #eee', borderRadius: 12, padding: 14, marginBottom: 14 }}>
          <select style={input} value={this.state.statusFilter} onChange={(e) => this.setState({ statusFilter: e.target.value }, this.refetchList)}>
            <option value="">All</option><option value="open">Open</option><option value="in_progress">In progress</option><option value="resolved">Resolved</option><option value="closed">Closed</option>
          </select>
          <button style={btn(RED)} onClick={() => this.setState({ nf: !this.state.nf })}>+ New ticket</button>
          {this.state.message ? <span style={{ marginLeft: 12, color: RED, fontWeight: 600 }}>{this.state.message}</span> : null}

          {this.state.nf && (
            <div style={{ marginTop: 12 }}>
              <input style={{ ...input, width: 280 }} placeholder="Subject" value={this.state.nSubject} onChange={(e) => this.setState({ nSubject: e.target.value })} />
              <input style={{ ...input, width: 200 }} placeholder="User email (optional)" value={this.state.nUserEmail} onChange={(e) => this.setState({ nUserEmail: e.target.value })} />
              <input style={{ ...input, width: 120 }} placeholder="Booking id" value={this.state.nBooking} onChange={(e) => this.setState({ nBooking: e.target.value.replace(/[^0-9]/g, '') })} />
              <select style={input} value={this.state.nPriority} onChange={(e) => this.setState({ nPriority: e.target.value })}><option value="low">Low</option><option value="normal">Normal</option><option value="high">High</option></select>
              <textarea style={{ ...input, width: 560, height: 80, display: 'block', marginTop: 8 }} placeholder="Description" value={this.state.nDescription} onChange={(e) => this.setState({ nDescription: e.target.value })} />
              <button style={btn(RED)} disabled={this.state.busy} onClick={this.createTicket}>Create</button>
            </div>
          )}
        </div>

        <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
          {/* List */}
          <div style={{ flex: '1 1 420px', background: '#fff', border: '1px solid #eee', borderRadius: 12, overflow: 'hidden' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
              <thead><tr style={{ background: '#fafafa' }}><th style={th}>#</th><th style={th}>Subject</th><th style={th}>Priority</th><th style={th}>Status</th></tr></thead>
              <tbody>
                {rows.length === 0 && <tr><td style={td} colSpan={4}>No tickets.</td></tr>}
                {rows.map((x) => (
                  <tr key={x.id} style={{ cursor: 'pointer', background: this.state.selectedId === x.id ? '#FFF6F4' : '#fff' }} onClick={() => this.open(x.id)}>
                    <td style={td}>#{x.id}</td>
                    <td style={td}>{x.subject}<div style={{ fontSize: 11, color: '#999' }}>{x.userEmail || ''}{x.bookingId ? ` · booking #${x.bookingId}` : ''}</div></td>
                    <td style={td}><span style={pBadge(x.priority)}>{x.priority}</span></td>
                    <td style={td}><span style={sBadge(x.status)}>{x.status}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Detail */}
          <div style={{ flex: '1 1 420px', background: '#fff', border: '1px solid #eee', borderRadius: 12, padding: 16 }}>
            {!t && <div style={{ color: '#999' }}>Select a ticket to view the conversation.</div>}
            {t && (
              <div>
                <div style={{ fontWeight: 800, fontSize: 17 }}>#{t.id} · {t.subject}</div>
                <div style={{ fontSize: 13, color: '#888', marginBottom: 10 }}>{t.userEmail || ''}{t.bookingId ? ` · booking #${t.bookingId}` : ''} · {t.category}</div>

                <div style={{ marginBottom: 12 }}>
                  <select style={input} value={t.status} onChange={(e) => this.update({ status: e.target.value })}>
                    <option value="open">Open</option><option value="in_progress">In progress</option><option value="resolved">Resolved</option><option value="closed">Closed</option>
                  </select>
                  <select style={input} value={t.priority} onChange={(e) => this.update({ priority: e.target.value })}>
                    <option value="low">Low</option><option value="normal">Normal</option><option value="high">High</option>
                  </select>
                  <button style={btn(INK)} disabled={this.state.busy} onClick={() => this.update({ assignedTo: 'me' })}>Assign to me</button>
                </div>

                <div style={{ borderTop: '1px solid #f0f0f0', paddingTop: 10, maxHeight: 280, overflowY: 'auto' }}>
                  {(t.messages || []).length === 0 && <div style={{ color: '#999' }}>No messages.</div>}
                  {(t.messages || []).map((m) => (
                    <div key={m.id} style={{ marginBottom: 10 }}>
                      <div style={{ fontSize: 11, color: '#999' }}>{m.authorEmail || m.authorType} · {m.createdAt ? m.createdAt.replace('T', ' ').slice(0, 16) : ''}</div>
                      <div style={{ background: '#F6F8FA', borderRadius: 8, padding: '8px 10px', fontSize: 14 }}>{m.body}</div>
                    </div>
                  ))}
                </div>

                <div style={{ marginTop: 10 }}>
                  <textarea style={{ ...input, width: '100%', height: 70 }} placeholder="Reply…" value={this.state.reply} onChange={(e) => this.setState({ reply: e.target.value })} />
                  <button style={btn(RED)} disabled={this.state.busy} onClick={this.sendReply}>Send reply</button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default compose(
  withQuery(getSupportTickets, { name: 'tickets', options: { variables: { currentPage: 1 }, fetchPolicy: 'network-only', ssr: false } }),
  withQuery(getTicketQ, { name: 'ticket', options: { variables: { id: 0 }, fetchPolicy: 'network-only', ssr: false } }),
  withMutation(createTicketM, { name: 'createMut' }),
  withMutation(updateTicketM, { name: 'updateMut' }),
  withMutation(addTicketMessageM, { name: 'replyMut' }),
)(SupportTickets);
